import myFlexiPlanSteps from "../enums/myFlexiPlanSteps";
import { find, propEq } from "ramda";

const stepFinder = (step) => find(propEq("name", step.name));
export const deviceStepFinder = stepFinder(myFlexiPlanSteps.device);
export const voiceStepFinder = stepFinder(myFlexiPlanSteps.voice);
export const dataStepFinder = stepFinder(myFlexiPlanSteps.data);
